import 'css-chunksrc/client/pages/projectPage/synthesisPage/milestones/styles.scss';export default {
  "milestones": "_milestones_1e3ss_1",
  "icon": "_icon_1e3ss_6",
  "milestone": "_milestone_1e3ss_1",
  "name": "_name_1e3ss_37",
  "status": "_status_1e3ss_46",
  "statusName": "_statusName_1e3ss_52",
  "endDate": "_endDate_1e3ss_60",
  "late": "_late_1e3ss_68",
  "done": "_done_1e3ss_73",
  "placeholder": "_placeholder_1e3ss_78"
};